import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.content}/v4/recommendations`, {
  get: {
    'recommendation.get': '/:pageId',
    'recommendation.getAdWidgetByAdId': '/:id/widget',
    'recommendation.getAll': ''
  },
  post: {
    'recommendation.create': ''
  },
  put: {
    'recommendation.update': '/:id'
  },
  delete: {
    'recommendation.delete': '/:id'
  }
});
